// removed by extract-text-webpack-plugin
module.exports = {"ineligibleIngredientsGetInTouch":"G4b035e"};